/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Saved_ToastInputs */



/**
* | output |
* | --- |
* | "Tag set changes saved" |
*
* @param {Tags_Manager_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_saved_toast = /** @type {((inputs?: Tags_Manager_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifications de l'ensemble de tags enregistrees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen am Tag-Satz gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifiche al set di tag salvate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранены изменения в наборе тегов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambios en el conjunto de etiquetas guardados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签集更改已保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグセットの変更を保存しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग सेट में किए गए बदलाव सहेज लिए गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterações no conjunto de tags salvas")
	return /** @type {LocalizedString} */ ("Tag set changes saved")
});